import "../css/style.scss"

const vysunuti = document.getElementById('navi-toggle');
// const zmizeni = document.getElementById('mobil');
const totop = document.querySelector('#tothetop');

// Open mobilní navi a nastaví body na no scroll
vysunuti.addEventListener('click', () => {
  mobil.classList.toggle('show-navi');
  // document.body.style.overflow = document.body.style.overflow === 'hidden' ? '' : 'hidden';  // toggle "overflow: hidden;" pro body element   
});


// Zavře mobilní navi a nastaví body zpět na scroll po kliknutí do menu
// zmizeni.addEventListener('click', e => {
//   mobil.classList.remove('show-navi');
//   // document.body.style.overflow = "scroll";
// });

// To the Top
totop.addEventListener('click', () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
});

// ============================================================================ //

window.onscroll = () => {
  const scroll = window.scrollY;
  showScrollTop(scroll);
};

// Adds a fixed menu on top
function showScrollTop(scroll) {
  // In the case that the scroll is greater than 600 add some classes
  if (scroll > 600) {
    totop.classList.add("to-top");
  } else {
    totop.classList.remove("to-top");
  }
}


